import {PopularProduct} from "components/general-settings/search-page/popular-product/PopularProduct";
import {useFetch} from "services/useFetch";
import {API_SEARCH_PAGE} from "services/apiSearchPage";
import {useState} from "react";
import {constructOptionMultipleSelect} from "utils/utils";

export const PopularProductContainer = ({searchPageDetail, onChangeForm, errorForm}) => {
    const dataProduct = {...searchPageDetail?.product_data}
    const { fetching: getProductList } = useFetch(API_SEARCH_PAGE.PRODUCT_LIST)
    const [optionsProduct, setOptionsProduct] = useState([])

    const onChangeProduct = (item) => {
        onChangeForm({ product_data: { ...dataProduct, ...item } })
    }

    const onSearchProduct = (keyword) => {
        getProductList({ search: keyword }).then((response) => {
            const newList = constructOptionMultipleSelect(response?.data, 'name', 'id')
            setOptionsProduct(newList)
        })
    }

    const props = {
        dataProduct,
        onSearchProduct,
        optionsProduct,
        onChangeProduct,
        errorForm,
    }

    return (
        <PopularProduct {...props}/>
    )
}
